import { CanvasTexture, UVMapping, RepeatWrapping, NearestFilter } from 'three';
import { GenerativeTexture } from '../types';
import { randColor } from '../utils';

export const powerUp = (): GenerativeTexture => {
  const size = 120;

  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

  const draw = () => {
    var grd = ctx.createLinearGradient(0, 50, 50, 0);
    grd.addColorStop(0, `rgb(${randColor().join(',')}`);
    grd.addColorStop(1, `rgb(${randColor().join(',')}`);
    // Fill with gradient
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, 120, 120);
  };

  draw();

  const texture = new CanvasTexture(
    canvas,
    UVMapping,
    RepeatWrapping,
    RepeatWrapping,
    NearestFilter,
    NearestFilter,
  );

  const frameTime = 1 / 12;
  let elapsed = 0;

  return {
    texture,
    canvas,
    step: delta => {
      elapsed += delta;
      if (elapsed > frameTime) {
        elapsed = elapsed % frameTime;
        draw();
        texture.needsUpdate = true;
      }
    },
  };
};
